export const defaultEstimatedReturn = 0.05;
export const defaultStandardDeviation = 0.08;
export const defaultTransactionCostIndirect = 0.0021;
export const defaultManagementCostRatio = 0.01;
